module.exports = __webpack_public_path__ + "static/07-c47dc2d63e038a79fdd0233fd36286a5.jpg";